<template>
  <el-dialog title="默认用法配置" :visible.sync="visible" width="400px" :close-on-click-modal="false"
    :close-on-press-escape="false" @close="handleClose">
    <el-form ref="form" :model="formData" :rules="rules" label-width="80px" class="form-container">
      <!-- 用药频次 -->
      <el-form-item label="用药频次" prop="useFrequency" label-class="form-label">
        <el-select v-model="formData.useFrequency" placeholder="请选择" class="form-select">
          <el-option v-for="item in dictData.useFrequency" :key="item.dictCode" :label="item.dictLabel"
            :value="item.dictCode+''" />
        </el-select>
      </el-form-item>

      <!-- 用药量 -->
      <el-form-item label="用药量" prop="singleDose" label-class="form-label">
        <div class="dose-wrapper">
          <span class="dose-label">1次</span>
          <el-input v-model="formData.singleDose" placeholder="请输入" class="form-input" />
          <el-select v-model="formData.singleDoseUnit" placeholder="袋" class="form-select dose-unit">
            <el-option v-for="item in dictData.singleDoseUnit" :key="item.dictCode" :label="item.dictLabel"
              :value="item.dictCode+''" />
          </el-select>
        </div>
      </el-form-item>

      <!-- 服用时间 -->
      <el-form-item label="服用时间" prop="takingTime" label-class="form-label">
        <el-select v-model="formData.takingTime" placeholder="请选择" class="form-select">
          <el-option v-for="item in dictData.takingTime" :key="item.dictCode" :label="item.dictLabel"
            :value="item.dictCode+''" />
        </el-select>
      </el-form-item>

      <!-- 间隔要求 -->
      <el-form-item label="间隔要求" prop="intervalRequirement" label-class="form-label">
        <el-select v-model="formData.intervalRequirement" placeholder="请选择" class="form-select">
          <el-option v-for="item in dictData.intervalRequirement" :key="item.dictCode" :label="item.dictLabel"
            :value="item.dictCode+''" />
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveOftenDecoction } from '@/api/outpatientDetail'
export default {
  name: 'DefaultUsageConfigDialog',
  props: {
    // 初始数据
    initData: {
      type: Object,
      default: () => ({})
    },
    dictData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      formData: {
        frequency: '', // 用药频次
        dose: '', // 用药量
        doseUnit: '袋', // 用药量单位
        takingTime: '', // 服用时间
        interval: '' // 间隔要求
      },
      rules: {
        useFrequency: [
          { required: true, message: '请选择用药频次', trigger: 'change' }
        ],
        singleDose: [
          { required: true, message: '请输入用药量', trigger: 'blur' },
          { pattern: /^[0-9]\d*(\.\d)?$/, message: '请输入大于0的数字，最多保留一位小数', trigger: 'blur' }
        ],
        takingTime: [
          { required: true, message: '请选择服用时间', trigger: 'change' }
        ],
        intervalRequirement: [
          { required: true, message: '请选择间隔要求', trigger: 'change' }
        ]
      },
    }
  },
  methods: {
    handleClose() {
      this.resetForm()
      this.visible = false
    },
    handleCancel() {
      this.resetForm()
      this.visible = false
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 提交数据
          saveOftenDecoction({ ...this.formData,handling:'' }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '配置成功',
                type: 'success'
              })
              this.$emit('confirm', { ...this.formData })
              this.resetForm()
              this.visible = false
            }
          })
        }
      })
    },
    resetForm() {
      this.formData = {
        useFrequency: '', //用药频次
        singleDose: '',// 单次用量
        singleDoseUnit: '',// 单次用量单位
        takingTime: '',//服用时间
        intervalRequirement: '',//时间间隔要求
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    open(item) {
      this.formData = item
      this.visible = true
    },
  }
}
</script>

<style lang="less" scoped>
.form-container {
  padding: 10px;
}

.form-label {
  font-weight: normal;

  ::v-deep .el-form-item__label {
    color: #333;
  }

  ::v-deep .el-form-item__label::before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
  }
}

.form-select {
  width: 100%;
}

.form-input {
  width: 120px;
  text-align: center;
}

.dose-wrapper {
  display: flex;
  align-items: center;
}

.dose-label {
  padding: 0 10px;
  font-size: 14px;
  color: #666;
}

.dose-unit {
  width: 80px;
  margin-left: 8px;
}

.dialog-footer {
  text-align: right;

  .el-button {
    margin-left: 12px;
  }
}
</style>
